import React from 'react'
import WithdrawalRow from './WithdrawalRow'
import { Withdraw } from '../../reducers/wallet.reducer'

interface WithdrawHistoryProps {
  pastWithdraws: Withdraw[]
  onCancelClick: (uuid: string) => void
  show: boolean
}

const WithdrawHistory: React.FC<WithdrawHistoryProps> = ({ pastWithdraws, onCancelClick, show }) => {
  if (!show) {
    return null
  }

  const mapWithdraws = () => {
    return pastWithdraws
      .filter((x) => !x.isProcessed)
      .map((x, i) => <WithdrawalRow key={i} withdrawal={x} index={i} handleCancelClick={onCancelClick} />)
  }

  return (
    <div
      className="withdraw-history-wrapper"
      style={{
        maxHeight: '200px',
      }}
    >
      <div className="table pt-20">{mapWithdraws()}</div>
    </div>
  )
}

export default WithdrawHistory
